var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psi"},[_c('div',{staticClass:"inCard"}),_c('div',{staticClass:"shop-header"},[_vm._v(" 处方发药 ")])])
}]

export { render, staticRenderFns }